export type PropertyToolType =
  | "TableOptions"
  | "Options"
  | "Select"
  | "ResponsiveColumn"
  | "Enum"
  | "Style"
  | "JSONEditor"
  | "Number"
  | "Boolean"
  | "String"
  | "Tags"
  | "Image"
  | "Icon"
  | "ColorPickerArray"
  | "ColorPicker"
  | "DateTime"
  | "ChartOptions"
  | "CalendarOptions"
  | "GoogleMapsOptions"
  | "KanbanBoardLaneOptions"
  | "KanbanBoardCardOptions"
  | "ChatOptions"
  | "MapMarkerProp"
  | "TimelineOptions"
  | "TreeOptions"
  | "MenuOptions"
  | "MicroAppProjectProp"
  | "MicroAppStartingScreenProp"
  | "RadialChartOptions"
  | "RadialChartLevelOptions"
  | "MixedChartOptions"
  | "MixedChartLineOptions"
  | "MixedChartPointOptions"
  | "MixedChartBarOptions"
  | "NestedTableOptions"
  | "DynamicFormatter"
  | "BreadcrumbOptions"
  | "DynamicFormEntity"
  | "DynamicFormAttributes"
  | "DynamicFormValue"
  | "NodeTreeNodeOptions"
  | "WidgetDomainType"
  | "WidgetDomainTypeObject"
  | "DirectoryOptions";

export type BackEndValueType =
  | "Unknown"
  | "Boolean"
  | "Bytea"
  | "Byte"
  | "Date"
  | "Datetime"
  | "DateTimeOffset"
  | "Decimal"
  | "Double"
  | "Guid"
  | "Int16"
  | "Int32"
  | "Int64"
  | "Single"
  | "String"
  | "AutoIncrement"
  | "Image"
  | "Array"
  | "Any"
  | "IFormCollection";
export enum EValueType {
  Unknown = 0,
  String = 1,
  Int32 = 2,
  Int64 = 3,
  Boolean = 4,
  Decimal = 5,
  DateTimeOffset = 6,
  Guid = 7,
  Double = 8,
  Int16 = 9,
  Bytea = 10,
  Byte = 11,
  Single = 12,
  Date = 13,
  DateTime = 14,
  Class = 100
}
